import { Injectable } from '@angular/core';
import { IFreightBasicForCarrier, IFreightBasicForShipper } from '@okcargo-apps/shared-domain';
import { GenerateAndDownloadEcmrQuery, GenerateAndDownloadLoadingOrderQuery } from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class FreightDocumentationService {
  public getLoadingOrderUrl(freight: IFreightBasicForCarrier | IFreightBasicForShipper, viewPrices: boolean): string {
    const query = {
      freightId: freight.id,
      // assignationId: freight.shipperCarrierAssignationId,
      driver: !viewPrices, // If 'false' the loading order contains price
      // language: this.account.lang, // TODO review, comer from old Torre de Control, but not work (download always in spanish)
    } as unknown as GenerateAndDownloadLoadingOrderQuery;
    return (
      '/services/query-processor/api/queries/download?name=GenerateAndDownloadLoadingOrderQuery&payload=' +
      encodeURI(JSON.stringify(query))
    );
  }

  public getECmrUrl(freight: IFreightBasicForCarrier | IFreightBasicForShipper): string {
    const query = {
      freightId: freight.id,
    } as GenerateAndDownloadEcmrQuery;
    return (
      '/services/query-processor/api/queries/download?name=GenerateAndDownloadEcmrQuery&payload=' +
      encodeURI(JSON.stringify(query))
    );
  }
}
